module.exports = __webpack_public_path__ + "media/images/icons/magnifier-43855e67e8b46bd19b3581cf48444082.svg";